<main id="main-content" aria-label="Course modules">
  @if (course) {
    <div class="content-contain mx-auto my-4">
      <div class="flex flex-col items-start gap-2 mb-2">
        <prism-btn
          btnClass="btn-white !w-auto"
          (click)="goBackToDetail()"
          ariaLabel="Back to course detail">
          <i class="uil uil-arrow-left"></i>
          Back to Course
        </prism-btn>
        <prism-title additionalClasses="text-4xl text-center sm:text-left" [title]="course.name"></prism-title>
      </div>
      <hr class="h-1 bg-dark-purple border-0 my-4">

      <prism-title additionalClasses="text-xl pt-3" title="Course Description" headingLevel="h2"></prism-title>
      <p>{{ course.description }}</p>

      <div class="flex justify-between items-center mt-8 mb-4">
        <prism-title additionalClasses="text-2xl" title="Modules" headingLevel="h2"></prism-title>
        <span class="text-sm text-gray-600">
          {{ completedCount }} / {{ rows.length }} Complete
        </span>
      </div>

      <div class="space-y-3" role="list" aria-label="Module list">
        @for (row of rows; track row.module.id) {
          <div role="listitem" class="border border-dark-purple rounded-md p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div class="flex items-center gap-3">
              <span
                class="inline-flex items-center justify-center w-7 h-7 rounded-full text-sm font-semibold"
                [ngClass]="{
                  'bg-green-100 text-green-700': row.status === CourseStatus.Completed,
                  'bg-yellow-100 text-yellow-700': row.status === CourseStatus.Incomplete,
                  'bg-gray-100 text-gray-600': row.status === CourseStatus.NotStarted
                }"
                aria-hidden="true">
                @if (row.status === CourseStatus.Completed) {
                  <i class="uil uil-check"></i>
                }
              </span>
              <span class="font-medium text-lg">{{ row.module.name }}</span>
              <span
                class="status-pill"
                [ngClass]="{
                  'completed': row.status === CourseStatus.Completed,
                  'incomplete': row.status === CourseStatus.Incomplete,
                  'not-started': row.status === CourseStatus.NotStarted
                }"
                aria-hidden="true">
                {{ row.status }}
              </span>
              <span class="sr-only">{{ row.status }}</span>
            </div>
            <prism-btn
              btnClass="btn-purple text-nowrap"
              (click)="openModule(row)"
              [ariaLabel]="buttonText(row) + ' ' + row.module.name">
              {{ buttonText(row) }}
            </prism-btn>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="content-contain mx-auto my-4">
      <p>Course not found.</p>
    </div>
  }
</main>

<ng-template #startModuleContent>
  <p class="modal-title">
    <strong>Please Note: To receive credit for {{ selectedModule?.name }} you must:</strong>
  </p>
  <ul class="bullet-points">
    @if (selectedRequiresMinimumStay) {
      <li>Remain in this module for at least {{ formatTimeout(selectedModule?.timeoutSeconds) }}</li>
    }
    <li>Complete this module</li>
    @if (selectedRequiresNotebookEntry) {
      <li>Add at least one PRISM Digital Notebook Entry for this module</li>
    }
    @if (selectedRequiresAcknowledgement) {
      <li>Click the Agree and Submit button</li>
    } @else {
      <li>Click the Complete button</li>
    }
  </ul>
</ng-template>
